export class WorldMapRoutes {
	constructor(routes) {
		this.routes = routes;
		this.current = 0;
		this.target = 0;
		this.previous = null;
		this.rendered = [];
		this.moving = false;
		this.together = false;
	}

	setProgress(progress, immediate = false) {
		this.together = false;
		this.updateTarget(progress, immediate);
	}

	setTogetherProgress(progress, immediate = false) {
		this.together = true;
		this.updateTarget(progress, immediate);
	}

	updateTarget(progress, immediate) {
		this.target = progress;
		if (immediate) {
			this.current = progress;
			this.moving = false;
			this.render();
		} else {
			if (!this.moving) this.previous = null;
			this.moving = Math.abs(this.target - this.current) > 0.001;
		}
	}

	tick(time) {
		if (!this.moving) return;
		const elapsed = this.previous === null ? 16 : Math.max(0, time - this.previous);
		this.previous = time;
		// Time-based easing keeps line drawing consistent across display refresh rates.
		const easing = this.together ? 180 : 110;
		this.current += (this.target - this.current) * (1 - Math.exp(-elapsed / easing));
		if (Math.abs(this.target - this.current) < 0.001) {
			this.current = this.target;
			this.moving = false;
		}
		this.render();
	}

	render() {
		this.routes.forEach((route, index) => {
			const routeProgress = this.together ? this.current : this.current - Number(route.dataset.region);
			const reveal = Math.round(Math.min(1, Math.max(0, routeProgress)) * 1000) / 1000;
			if (this.rendered[index] === reveal) return;
			this.rendered[index] = reveal;
			route.style.strokeDashoffset = 1 - reveal;
			route.style.opacity = reveal > 0 ? 1 : 0;
		});
	}
}
